import React from 'react';
import Constant from '../Constant';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDataCounts, getSalesAndOrdersByDateRange } from '../actions';
import axios from 'axios';

const AdminDashboard = () => {
  const [dataCounts, setDataCounts] = useState({
    totalUsers: 0,
    totalServiceProviders: 0,
    totalActiveMemberships: 0,
    totalSalesThisMonth: 0,
    totalSales: 0,
    totalOrders: 0,
  });
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredMetrics, setFilteredMetrics] = useState({
    totalSales: 0,
    totalOrders: 0,
  });
  const [selectedCategory, setSelectedCategory] = useState('garageOwners');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDataCounts());
  }, [dispatch]);

  const data = useSelector((state) => state.home.dataCounts);
  const customData = useSelector((state) => state.home.customDataCounts);

  console.log('data', data);
  console.log('customData', customData);

  useEffect(() => {
    setDataCounts(data);
  }, [data]);

  useEffect(() => {
    setFilteredMetrics(customData);
  }, [customData]);

  const serviceProviderBreakdown = dataCounts?.serviceProviderBreakdown || {};

  const displayName = selectedCategory
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());

  const selectedValue = serviceProviderBreakdown[selectedCategory] || 0;

  const handleFetchSalesOrders = async () => {
    if (!startDate || !endDate) {
      alert('Please select both start and end dates.');
      return;
    }

    dispatch(getSalesAndOrdersByDateRange({ startDate, endDate }));
  };

  return (
    <div className="pcoded-inner-content">
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Dashboard</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <h3 className="text-primary">Welcome Car Avenue Admin</h3>
            <div className="row">
              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-green f-w-600">
                          {dataCounts?.totalSales || 0} KD.
                        </h4>
                        <h6 className="text-muted m-b-0">Total Sales</h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-coins f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-green"></div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-green f-w-600">
                          {dataCounts?.totalSalesThisMonth || 0} KD.
                        </h4>
                        <h6 className="text-muted m-b-0">
                          Total Sales this Month
                        </h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-money-bag f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-green"></div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-yellow f-w-600">
                          {dataCounts?.totalOrders || 0}
                        </h4>
                        <h6 className="text-muted m-b-0">Total Orders</h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-shopping-cart f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-yellow"></div>
                </div>
              </div>
              {/* <div className='col-xl-3 col-md-6'>
									<div className='card'>
										<div className='card-block'>
											<div className='row align-items-center'>
												<div className='col-8'>
													<h4 className='text-c-pink f-w-600'>{20}</h4>
													<h6 className='text-muted m-b-0'>Total Shops</h6>
												</div>
												<div className='col-4 text-right'>
													<i className='feather icon-alert-triangle f-28'></i>
												</div>
											</div>
										</div>
										<div className='card-footer bg-c-pink'></div>
									</div>
								</div> */}
              {/* <div className='col-xl-3 col-md-6'>
									<div className='card'>
										<div className='card-block'>
											<div className='row align-items-center'>
												<div className='col-8'>
													<h4 className='text-c-blue f-w-600'>{30}</h4>
													<h6 className='text-muted m-b-0'>Total Products</h6>
												</div>
												<div className='col-4 text-right'>
													<i className='feather icon-award f-28'></i>
												</div>
											</div>
										</div>
										<div className='card-footer bg-c-blue'></div>
									</div>
								</div> */}

              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-orenge f-w-600">
                          {dataCounts?.totalUsers || 0}
                        </h4>
                        <h6 className="text-muted m-b-0">Total Users</h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="feather icon-users f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-orenge"></div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-yellow f-w-600">
                          {dataCounts?.totalServiceProviders || 0}
                        </h4>
                        <h6 className="text-muted m-b-0">
                          Total Service Providers
                        </h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-tools-alt-2 f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-yellow"></div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div>
                        <h4 className="text-c-orenge f-w-600">
                          {dataCounts?.totalActiveMemberships || 0}
                        </h4>
                        <h6 className="text-muted m-b-0">
                          Total Active Membership
                        </h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-verification-check f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-orenge"></div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-blue f-w-600">{selectedValue}</h4>
                        <h6 className="text-muted m-b-0">{displayName}</h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-briefcase-alt-2 f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-blue p-2">
                    <select
                      className="form-control"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                      {Object.keys(serviceProviderBreakdown).map((key) => (
                        <option key={key} value={key}>
                          {key
                            .replace(/([A-Z])/g, ' $1')
                            .replace(/^./, (str) => str.toUpperCase())}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-4">
                  <label>Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <label>End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="col-md-3 d-flex align-items-end">
                  <button
                    className="btn btn-primary w-100"
                    onClick={handleFetchSalesOrders}
                  >
                    Get
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-purple f-w-600">
                          {filteredMetrics?.totalSales || 0} KD.
                        </h4>
                        <h6 className="text-muted m-b-0">
                          Sales in Selected Range
                        </h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-coins f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-purple"></div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6">
                <div className="card">
                  <div className="card-block">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="text-c-purple f-w-600">
                          {filteredMetrics?.totalOrders || 0}
                        </h4>
                        <h6 className="text-muted m-b-0">
                          Orders in Selected Range
                        </h6>
                      </div>
                      <div className="col-4 text-right">
                        <i className="icofont icofont-shopping-cart f-28"></i>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-c-purple"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="styleSelector"></div>
      </div>
    </div>
  );
};

export default AdminDashboard;
